import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numbersToWords'
})
export class NumbersToWordsPipe implements PipeTransform {

  // transform(value: unknown, ...args: unknown[]): unknown {
  //   return null;
  // }
  private ones: string[] = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
    'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];

  private tens: string[] = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  private digitWords: string[] = [
    'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'
  ];

  transform(
    value: number | string,
    unit: string = 'Rupee',
    subunit: string = 'Paise',
    mode: 'currency' | 'unit' = 'currency'
  ): string {
    if (value == null || isNaN(Number(value))) return '';



const num = Number(value);
const fixed = num.toFixed(mode === 'unit' ? 3 : 2);
const [wholeStr, decimalStr] = fixed.split('.');
const whole = Number(wholeStr);
const decimal = decimalStr || '';

if (whole > 10000000000) {
  return 'Amount too large';
}

let wordParts: string[] = [];

if (whole === 0) {
  // wordParts.push('Zero');
} else {
  wordParts = this.splitIndianNumberIntoWordParts(whole);
}

if (unit) {
  wordParts[wordParts.length - 1] += ` ${whole === 1 ? unit : this.pluralize(unit)}`;
}

if (decimal && Number(decimal) > 0) {
  if (mode === 'currency') {
    const paiseWords = this.splitIndianNumberIntoWordParts(Number(decimal)).join(', ');
    wordParts.push(`${paiseWords} ${this.pluralize(subunit)}`);
  } else {
    const decimalWords = decimal.split('').map(d => this.digitWords[+d]).join(' ');
    wordParts.push(`Point ${decimalWords}`);
  }
}

return wordParts.join(', ');
  }

  private splitIndianNumberIntoWordParts(num: number): string[] {
    const parts: string[] = [];



const arab = Math.floor(num / 1000000000);
num %= 1000000000;

const crore = Math.floor(num / 10000000);
num %= 10000000;

const lakh = Math.floor(num / 100000);
num %= 100000;

const thousand = Math.floor(num / 1000);
num %= 1000;

const hundred = Math.floor(num / 100);
num %= 100;

if (arab > 0) parts.push(this.convertTwoDigits(arab) + ' Arab');
if (crore > 0) parts.push(this.convertTwoDigits(crore) + ' Crore');
if (lakh > 0) parts.push(this.convertTwoDigits(lakh) + ' Lakh');
if (thousand > 0) parts.push(this.convertTwoDigits(thousand) + ' Thousand');
if (hundred > 0) parts.push(this.ones[hundred] + ' Hundred');
if (num > 0) parts.push(this.convertTwoDigits(num));

return parts;
  }

  private convertTwoDigits(num: number): string {
    if (num < 20) return this.ones[num];
    return this.tens[Math.floor(num / 10)] + (num % 10 ? ' ' + this.ones[num % 10] : '');
  }

  private pluralize(word: string): string {
    return word.endsWith('s') ? word : word + 's';
  }
}